export default __webpack_public_path__ + "static/media/s4.3a610638.png";